import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';

import Button from 'components/Common/Buttons';
import ModalWrapper from 'components/Modals/ModalWrapper';

const FormConfirmation = ({
  onConfirm,
  onCancel,
  intl,
  previewOnlyMode,
  isFetchingPdf,
  onClickHandler,
}) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const formConfirmationTitle = <h1>Generated Form Preview</h1>;

  const formConfirmationMessage = <span>
    <FormattedHTMLMessage id={ previewOnlyMode ? 'formPreview.previewOnlyMode.content' : 'formPreview.content' } />
    <div className="mt-2">
      <Button
        value={ intl.formatMessage({ id: 'formPreview.download.buttonText' }) }
        className={ `btn-secondary btn-download mr-0 ${ isFetchingPdf ? 'btn-active' : '' }` }
        onClick={ () => onClickHandler() }
      />
    </div>
    { !previewOnlyMode && <label className="form-checkbox">
      <input id="certifyCheckbox" type="checkbox" onClick={ () => setIsConfirmed(!isConfirmed) } />
      <i className="form-icon" />
      <FormattedHTMLMessage id="formPreview.confirmLabel" />
    </label> }
  </span>;

  return (
    <ModalWrapper
      title={ formConfirmationTitle }
      content={ formConfirmationMessage }
      onCancel={ onCancel }
      onConfirm={ onConfirm }
      showCancel={ false }
      disableConfirm={ !previewOnlyMode && !isConfirmed }
      footer={ !previewOnlyMode && !isConfirmed && <span className="confirmationText"><FormattedHTMLMessage id="formPreview.confirmMessage" /></span> }
    />
  );
};

FormConfirmation.defaultProps = {
  previewOnlyMode: false,
  isFetchingPdf: false
};

FormConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isFetchingPdf: PropTypes.bool,
  previewOnlyMode: PropTypes.bool
};

export default FormConfirmation;
